import { useQueryClient } from '@tanstack/react-query';
import { cacheKeys, useCustomMutation } from '../../graphql';

type UpdateProductProps = {
  productId: string;
};

export const useUpdateProduct = (props: UpdateProductProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateProduct, isPending: isLoading } = useCustomMutation({
    query: UPDATE_PRODUCT,
  });
  const filter = {
    product: { eq: props.productId },
  };

  const cacheKey = cacheKeys('product').list({ filter });

  const clearCache = async () => {
    await queryClient.invalidateQueries({ queryKey: cacheKey });
  };

  return {
    updateProduct,
    clearCache,
    isUpdating: isLoading,
  };
};

const UPDATE_PRODUCT = `
  mutation UpdateProduct($input: MutateProductInput!) {
    updateProduct(input: $input) {
      id
      coverImage {
        id
        name
        extension
        status
        type
        createdAt
        updatedAt
      }
    }
  }
`;
